import { render, staticRenderFns } from "./Public.vue?vue&type=template&id=5d724f96&"
import script from "./Public.vue?vue&type=script&lang=js&"
export * from "./Public.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d724f96')) {
      api.createRecord('5d724f96', component.options)
    } else {
      api.reload('5d724f96', component.options)
    }
    module.hot.accept("./Public.vue?vue&type=template&id=5d724f96&", function () {
      api.rerender('5d724f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/layouts/Public.vue"
export default component.exports